import { render, staticRenderFns } from "./card-page.vue?vue&type=template&id=e5b60e5c"
import script from "./card-page.vue?vue&type=script&lang=js"
export * from "./card-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports